<template>
	<div class="d-flex flex-1 h-100 overflow-hidden">
		<v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">Manage Dispatch Recipients</v-toolbar-title>
            </v-toolbar>
            <div>
				<div class="row p-4">
					<div class="col-md-6">
						<StructureUserSelector :showInternalUsers="false" :showExternalUsers="false" :showInternalStructures="true"
								:showExternalStructures="false" :excludeSelf="true" :isMultiple="false"
								:addressBook_header="$t('res_Label_SelectSignee')"
								@structureUserSelectChanged="structureSelectedChange"
								style="width: 100%">
						</StructureUserSelector>
					</div>
					<div class="col-md-6">
						<v-btn @click="addDispatchEntity" width="150px" color="primary">Add</v-btn>
					</div>
				</div>
			</div>
			<div class="d-flex flex-1 flex-column overflow-auto p-4" style="padding: 5px">
				<v-data-table :headers="headers" :items="displayedItems"  item-key="id" disable-sort hide-default-footer class="elevation-1"
					:items-per-page="displayedItems.length">
					<template v-slot:item="row">
						<tr>
							<td>{{ row.item.name }}</td>
                            <td>{{ row.item.entityName }} </td>
							<td class="text-start">
								<div class="onhover-display">
									<div class="custom-icon-wrapper">
										<v-icon small @click="openDeleteDialog(row.item)">custom-icon white-bg delete-icon</v-icon>
									</div>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
	</div>
</template>
<script>
	import axios from "axios";
	import constants from "@/assets/js/constants.js"
	import router from '@/router/index.js'
    import StructureUserSelector from '@/components/StructureUserSelector.vue'

	export default {
		components: { StructureUserSelector },
		data() {
			return {
				user_structures: [],
				user_structure: {},
				loading: false,
				headers: [
					{ text: "Recipient", value: "name", align: "start", width: "30%" },
					{ text: "Entity Name", value: "entityName", align: "start", width: "30%" },
					{ text: "Actions", value: "actions", align: "start", width: "10%" },
				],
				checked: false,
				displayedItems: [],
			};
		},
		methods: {
			backToAdminPage()
			{
				router.push({ name: 'admin' })
			},
			structureSelectedChange(item, index) 
			{
				console.log(item)
				this.user_structure = item;
			},
			async fetchData() 
			{
				const res = await axios
					.get(constants.baseApiUrl + "Dispatch/GetDispatchEntities")
					.then((res) => {
						this.displayedItems = res.data;
					})
					.catch((error) => console.error("Error fetching data:", error));
			},
			addDispatchEntity() 
			{
				if (this.user_structure.id == null || this.user_structure.id == undefined || this.user_structure.id == ''){
					return false;
				}
			
				axios.post(constants.baseApiUrl + 'Dispatch/AddDispatchEntity?structureId=' + this.user_structure.id)
					.then(res => 
					{
						if (res == undefined || res.data == null)
							window.showAlert('res_Msgs_ErrorOccured', 'error')
						else
						{
							window.showAlert('res_Msgs_DispatchEntitiesAdded', 'success')
							this.fetchData()
						}
					})
					.catch(err => {
						this.handleError(err); window.hideLoading();
					}).finally(() => window.hideLoading())
			},
			openDeleteDialog(item) 
			{
				console.log(item)
				window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
					() => 
					{
						axios.post(constants.baseApiUrl + "Dispatch/DeleteDispatchEntity?id=" + item.id)
							.then((res) => this.fetchData())
							.catch((err) => console.log(err));
					},
					() => { })
			}
		},
		mounted() 
		{
			this.fetchData()
		}
	};
</script>

<style scoped>
	.v-card__title { align-items: normal; }
</style>